"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePixPayload = void 0;
var react_1 = require("react");
var pixPayload_1 = require("./pixPayload");
function usePixPayload(params) {
    var _a = (0, react_1.useState)(['', null]), result = _a[0], setResult = _a[1];
    (0, react_1.useEffect)(function () {
        try {
            setResult([(0, pixPayload_1.pixPayload)(params), null]);
        }
        catch (e) {
            setResult(['', e]);
        }
    }, [params]);
    return result;
}
exports.usePixPayload = usePixPayload;
//# sourceMappingURL=pixPayloadHook.js.map